import { createEntityAdapter } from '@ngrx/entity';
import { errorActions } from '../actions';
export const errorAdapter = createEntityAdapter({
    selectId: (item) => item.id,
    sortComparer: false
});
export const INIT_STATE = errorAdapter.getInitialState();
export function reducer(state = INIT_STATE, action) {
    switch (action.type) {
        case errorActions.ADD_ERROR: {
            return errorAdapter.addOne(action.payload, state);
        }
        case errorActions.REMOVE_ERROR: {
            return errorAdapter.removeOne(action.payload.id, state);
        }
        case errorActions.REMOVE_ERROR_BY_ID: {
            return errorAdapter.removeOne(action.payload, state);
        }
        case errorActions.CLEAR_ALL_ERRORS: {
            return errorAdapter.removeAll(state);
        }
        default: {
            return state;
        }
    }
}
//# sourceMappingURL=error.js.map